import { render, staticRenderFns } from "./DeleteComponentDialog.vue?vue&type=template&id=7adcb06c&scoped=true&"
import script from "./DeleteComponentDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteComponentDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adcb06c",
  null
  
)

export default component.exports